import { isFeaturedSofaType } from '@/configurator/shapeConfig'

export type ErpShapeMappingStatus = 'MAPPED' | 'UNMAPPED' | 'IGNORED'

/** An ErpShapeMapping as returned by the ErpShapeMappingFields fragment. */
export interface ErpShapeMappingRow {
  id: number
  createdAt: string
  updatedAt: string
  manufacturerId: number
  erp_schematic_id: string
  sofa_form_type: string | null
  /** Json: an object, or a legacy JSON string. */
  default_parameters: unknown
  status: ErpShapeMappingStatus
  erp_image_url: string | null
  erp_image_thumb_url: string | null
  notes: string | null
  last_seen_in_erp_at: string | null
  erp_item_count: number | null
  erp_sample_items: string[]
}

export interface ManufacturerOption {
  id: number
  manufacturer_profiles: { id: number; name: string | null; language: string }[]
}

export const errorMessage = (error: unknown, fallback: string) =>
  error instanceof Error && error.message ? error.message : fallback

/** A MAPPED row whose type is outside the picker's standard families. */
export const isNonStandardMapping = (
  m: Pick<ErpShapeMappingRow, 'status' | 'sofa_form_type'>
) => m.status === 'MAPPED' && !!m.sofa_form_type && !isFeaturedSofaType(m.sofa_form_type)
